module.exports = __webpack_public_path__ + "static/media/Prompt-S1-Lockup-Regular.516451ba.png";